import { useNavigate, useLocation } from 'react-router-dom';

import { type Topic } from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/types';
import { getSearchNavigationPath } from 'hb-react/shared/components/SearchButton/utils';

export const useSearchTopic = ({ topic }: { topic: Topic }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = () => {
    // Define path and options depending on a type of scope for search.
    const path = getSearchNavigationPath({
      scopeType: 'topic',
      scopeObject: { id: topic.id.toString() },
    });
    // Current location needed for "Back" button on search page.
    const options = { state: { from: location } };

    navigate(path, options);
  };

  return { handleSearch };
};
